import React, { useEffect, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from '../../Components/Reusable/CustomTextArea';
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import { toast } from "react-toastify";
import TestimonialService from "../../Services/TestimonialService";

const AddTestimonial = () => {
  const location = useLocation();
  const TestimonialData = location.state || null;
  const [testimonialEdit, setTestimonialEdit] = useState({ ...useLocation().state });
  const [uploadedDocuments, setUploadedDocuments] = useState(Array());


  const navigate = useNavigate();

  const Validations = yup.object().shape({
    name: validationRegex.required,
    // designation: validationRegex.required,
    feedback: validationRegex.required,
    image: validationRegex.required,
  });

  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    formState: { errors: errors },
    getValues: getValues,
    reset: reset,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      name: testimonialEdit?.name || "",
      designation: testimonialEdit?.designation || "",
      answer: testimonialEdit?.answer || "",
      feedback: testimonialEdit?.feedback || "",
      image: testimonialEdit?.image || "",
    },
  });



  const addTestimonial = async (testimonial) => {


    try {
      // Call TestimonialService to add the blog
      const response = await TestimonialService.AddTestimonial(
        testimonialEdit.testimonial_id || "",
        testimonial.name,
        testimonial.designation,
        testimonial.feedback,
        uploadedDocuments,
      );
      toast.success(response.message);
      navigate(RoutesPath.testimonial);
      setTestimonialEdit({})
    } catch (error) {
      handleApiErrors(error);
      toast.error("Failed to add Testimonial. Please try again later.");
    }
  };

  useEffect(() => {
    if (testimonialEdit) {
      setValues("name", testimonialEdit?.name || "");
      setValues("designation", testimonialEdit?.designation || "");
      setValues("answer", testimonialEdit?.answer || "");
      setValues("feedback", testimonialEdit?.feedback || "");
      setValues("image", testimonialEdit?.image || "");
      setUploadedDocuments(testimonialEdit?.image)
    }
  }, [testimonialEdit, setValues]);



  const onSubmit = (data) => {
    addTestimonial(data);
  };
  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">TESTIMONIAL </h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Testimonial</h4>
        </div>
      </div>

      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {`${!testimonialEdit?.testimonial_id ? "Add" : "Update"}`}{" "}
              Testimonial
            </h1>
          </div>
          <form>

            <div className="row profile_inputs w-100 mt-5">
              <div className="col-md-6 mb-3">
                <label className="login_heading">Main Image<span className="danger fs-14 fw-400 mt-1">*</span></label>
                <div className="position-relative select_file ">
                  <input className="choose-file"
                    type="file"
                    name="image"
                    id="image"
                    setValue={setValues}
                    accept="image/jpeg, image/jpg, image/webp"
                    {...register("image")}
                    // showError={errors?.image}
                    // errorMessage={errors?.image?.message}
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        const file = e.target.files[0];
                        const validTypes = ["image/jpeg", "image/jpg", "image/webp"];
                        if (!validTypes.includes(file.type)) {
                          toast.error("Only JPG, JPEG, and WEBP files are allowed.");
                          e.target.value = null;
                        } else {
                          setUploadedDocuments(file);
                        }

                      }
                    }}
                  />

                </div>
                <span className="danger fs-14 fw-400 mt-1">(Extension: jpg. jpeg.webp) Note:Dimension Size 1000x600 px</span>
                {testimonialEdit.image && (
                  <span className="text-success fs-14 fw-400 mt-1">Selected file: {testimonialEdit.image}</span>
                )}
                {errors.image && (
                  <p className="danger fs-14 fw-400 mt-1">{errors.image.message}</p>
                )}
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Name"
                  placeholder="Name"
                  name="name"
                  id="name"
                  InputType={InputType.text}
                  showMandatory={true}
                  setValue={setValues}
                  register={register}
                  additionalClasses="profile_edit"
                  showError={errors?.name}
                  errorMessage={errors?.name?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Designation"
                  placeholder="Designation, Company Name"
                  name="designation"
                  id="designation"
                  inputType={InputType.text}
                  showMandatory={false}
                  setValue={setValues}
                  register={register}
                  additionalClasses="profile_edit"
                  showError={errors?.designation}
                  errorMessage={errors?.designation?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextArea
                  labelTitle="Feedback"
                  placeholder="Feedback"
                  name="feedback"
                  id="feedback"
                  inputType={InputType.text}
                  showMandatory={true}
                  additionalClasses="profile_edit"
                  setValue={setValues}
                  register={register}
                  showError={errors?.feedback}
                  errorMessage={errors?.feedback?.message}
                />
              </div>
              <div className="d-flex justify-content-end">
                <ButtonWithIcon
                  text={testimonialEdit?.testimonial_id ? "Update" : "Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddTestimonial;
